module.exports = __webpack_public_path__ + "../resources/img/ic_re_air_conditioner_p2.d5f0f844.svg";